export default __webpack_public_path__ + "quote-section.png";